import Boolean from "./boolean/PluginSetup.js";
import Enum from "./enum/PluginSetup.js";
import GeoPoint from "./geoPoint/PluginSetup.js";
import Numeric from "./numeric/PluginSetup.js";
import ParentRelationship from "./parentRelationship/PluginSetup.js";
import ResourceEnum from "./resourceEnum/PluginSetup.js";
import Shared from "./shared/PluginSetup.js";
import String from "./string/PluginSetup.js";
import Unit from "./unit/PluginSetup.js";
export default {
  install(molten) {
    Boolean.install(molten);
    Enum.install(molten);
    GeoPoint.install(molten);
    Numeric.install(molten);
    ParentRelationship.install(molten);
    ResourceEnum.install(molten);
    Shared.install(molten);
    String.install(molten);
    Unit.install(molten);
  }
};